import React from "react";
import Select from "react-select";
import "./UserModal.css";
import { surveyapi } from "../../APIs/API";
import { getParameterByName, token } from "../../Utils/Function";
import { surveyurl } from "../../Utils/Bootstrap";
import { monthNames, languageList } from "../../Utils/Helper";
import $ from 'jquery';
export default class UserModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: { value: "en", label: "English" },
      name: null,
      mobile: null,
      address: null,
      stateid: null,
      lengthres: null,
      state: [],
      vsabha: [],
      boothno: null,
      stateList: [],
      vsabhaList: [],
      boothList: [],
    };
  }

  componentDidMount() {
    this.getStateList();
    this.getUserDetails();
  }

  componentWillUnmount() {}
  onChange = (e, type) => {
    if(type === "name") {
      this.setState({name: e.target.value }, () => {
        if (!this.state.name) {
          document
            .getElementById("userName")
            .setAttribute("style", "border-color:red");
            document.getElementById("nameerrorr").innerHTML =
            "Please enter your Name*";
          return;
        } else {
          document
            .getElementById("userName")
            .setAttribute("style", "border-color:green");
            document.getElementById("nameerrorr").innerHTML = "";
        }
      });      
    } else if(type === "mobile" ) {
        this.setState({mobile: e.target.value}, () => {
          if (!this.state.mobile) {
            document
              .getElementById("numbers")
              .setAttribute("style", "border-color:red");
              document.getElementById("moberrorr").innerHTML =
              "Please enter your Mobile Number*";
            return;
          } else {          
            document.getElementById("moberrorr").innerHTML = "";
            document
              .getElementById("numbers")
              .setAttribute("style", "border-color:green");
          }
        });      
      } else if(type === "address") {
        if (e.target.value.trim() || e.target.value.trim().length > 8) {
          document
            .getElementById("residence")
            .setAttribute("style", "border-color:green");
          document.getElementById("errorr").innerHTML = "";
          document.getElementById("lengtherr").innerHTML = "";          
        } else {
          document
            .getElementById("residence")
            .setAttribute("style", "border-color:red");
          document.getElementById("errorr").innerHTML =
            "";
            document.getElementById("lengtherr").innerHTML = "";
            this.setState({ lengthres: e.target.value.length });
          }
      }
    
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleChange = async (val, type) => {
    this.setState({ [type]: val });
    if (type === "lang") {
      this.getStateList();
      this.props.getDetailsData(val.value);
    }
    if (type === "state") {
      this.getVidhansabhaList(val.value);
    }
  };

  getUserDetails = async () => {
    let userid = await getParameterByName("userid");
    if (!userid) {
      return null;
    }
    let data = new FormData();
    data.append("action", "getuserdetail");
    data.append("userid", userid);
    data.append("addressid", userid);
    data.append("quiz_token", localStorage.getItem("quiz_token"));
    let surveyapicall = surveyapi.survey(data, surveyurl);
    let thisVar = this;
    surveyapicall.done((response) => {
      let resObj = JSON.parse(response);
      let resp = resObj && resObj ? resObj : null;
      if (resp && resp.user_name_display) {
        let name = resp.user_name_display;
        let mobile = resp.user_contact_no || null;
        thisVar.setState({ name: name, mobile: mobile });
      }
    });
  };
  getFormData = async (action, sid = null) => {
    let data = new FormData();
    let userid = await getParameterByName("userid");
    data.append("action", action);
    if (userid) {
      data.append("userid", userid);
      data.append("addressid", userid);
    } else {
      data.append("token", token);
    }
    if (sid) {
      data.append("state_id", sid);
    }
    data.append("quiz_token", localStorage.getItem("quiz_token"));
    data.append("lang", this.state.lang.value);

    let surveyapicall = surveyapi.survey(data, surveyurl);
    surveyapicall.done((response) => {
      let resObj = JSON.parse(response);
      // if (resObj._resultflag === "1")
      if (action === "getstatelist") {
        let stateListArr = [];
        resObj.data &&
          resObj.data.map((data) => {
            stateListArr.push({ value: data.stateid, label: data.statename });
          });
        this.setState({ stateList: stateListArr });
      } else if (action === "getvidhansabhalist") {
        let vsabhaListArr = [];
        resObj.data &&
          resObj.data.map((data) => {
            vsabhaListArr.push({ value: data.vs_id, label: data.vs_name });
          });
        this.setState({ vsabhaList: vsabhaListArr });
      }
      // }
    });
  };

  getStateList = async () => {
    await this.getFormData("getstatelist");
  };
  getVidhansabhaList = async (sid) => {
    await this.getFormData("getvidhansabhalist", sid);
  };

 
  validatePhoneNumber = (inputtxt) => {
    var phoneno = /^(0|91|\+91)?-?[789]\d{9}$/;
    // var phoneno = /^\+(?:[0-9] ?){6,14}[0-9]$/;
    if(inputtxt.match(phoneno)) {
        return true;
          } else {
          return false;
          }
  }
  onSubmit = async () => {
    let { name, mobile, address, state, vsabha, boothno, lang , lengthres} = this.state;
    
    localStorage.setItem("userName", name);
    localStorage.setItem("lang", lang.value);
    let karyakartas = {
      state: state.label || null,
      vsabha: vsabha.label || null,
      boothno: boothno || null,
    };
    localStorage.setItem("karyakartas", JSON.stringify(karyakartas));
    if (!name) {
      document
        .getElementById("userName")
        .setAttribute("style", "border-color:red");
        document.getElementById("nameerrorr").innerHTML =
        "Please enter your Name*";
      return;
    } else {
      document
        .getElementById("userName")
        .setAttribute("style", "border-color:green");
        document.getElementById("nameerrorr").innerHTML = "";
    }
    if (!mobile) {
      document
        .getElementById("numbers")
        .setAttribute("style", "border-color:red");
        document.getElementById("moberrorr").innerHTML =
        "Please enter your Mobile Number*";
      return;
    } else {
      document.getElementById("moberrorr").innerHTML = "";
      document
        .getElementById("numbers")
        .setAttribute("style", "border-color:green");
    }
    if (mobile.indexOf("+91") < 0 && !this.validatePhoneNumber(mobile)) {
      document
      .getElementById("numbers")
      .setAttribute("style", "border-color:red");
      document.getElementById("moberrorr").innerHTML =
      "Please enter your valid Mobile Number*";
    return;
    } else {
      document.getElementById("moberrorr").innerHTML = "";
      document
        .getElementById("numbers")
        .setAttribute("style", "border-color:green");
    }
    
    if (!address) {      
    // if (!address || address.trim().length < 8) {      
      document
        .getElementById("residence")
        .setAttribute("style", "border-color:red");
      document.getElementById("errorr").innerHTML =
        "Please enter your Address*";
      return;
    } else if(address.trim().length < 8) {
      document
      .getElementById("residence")
      .setAttribute("style", "border-color:red");
    document.getElementById("errorr").innerHTML =
      "Atleast 8 Charachter length is required*";
    return;
    } else {      
      document
        .getElementById("residence")
        .setAttribute("style", "border-color:green");
        document.getElementById("errorr").innerHTML =
        "";
      document.getElementById("lengtherr").innerHTML = "";
    }

    // if(document.getElementById("residence").value.length > 8){
    //   document.getElementById("lengtherr").innerHTML = "";
    //   document
    //     .getElementById("residence")
    //     .setAttribute("style", "border-color:green");
    // } else {
    //   document.getElementById("lengtherr").innerHTML = "Atleast 8 Charachter length is required*";
    //   document
    //     .getElementById("residence")
    //     .setAttribute("style", "border-color:red");
    //     return;
    // }

    // return;
    if (lang.value === "hi") {
      await this.props.getDetailsData(lang.value);
    }
    this.props.hideModal();
    let userid = await getParameterByName("userid");
    let quizid = await getParameterByName("quizid");

    let data = new FormData();
    data.append("action", "postuserquiz");
    data.append("survey_id", quizid);
    data.append("platform", "pwa");

    if (userid) {
      data.append("userid", userid);
      data.append("addressid", userid);
    } else {
      data.append("token", token);
    }
    data.append("quiz_token", localStorage.getItem("quiz_token"));

    let userDatails = {
      name: name,
      mobile: mobile,
      address: address,
      state: state,
      vsabha: vsabha,
      boothno: boothno,
      lang: lang,
    };
    data.append("userDetails", JSON.stringify(userDatails));
    try {
      let users = surveyapi.survey(data, surveyurl);
      let thisVar = this;
      users.done((response) => {
        let resObj = JSON.parse(response);
        if (resObj._resultflag === "1") {
          thisVar.props.hideModal();
        }
      });
    } catch (error) {
      console.log("error", error);
    }
  };
  render() {
    const { stateList, vsabhaList, state, vsabha, lang, langList } = this.state;
    const { title, complete_msg, survey_desc } = this.props;
    let d = new Date();
    let month = monthNames[d.getMonth()];
    let year = d.getFullYear();
    return (
      <div className="container-fluid">
        <div className="modal_overlay">
          <div className="modal_body">
            {/* <div className="close_btn" onClick={this.props.hideModal}><img src="assets/images/close_white.svg" /></div> */}
            <h2 className="nm_quiz_title ">
              {title ||
                `Winners of the quiz will get a BOOK SIGNED BY MODI JI.`}
            </h2>
            <h3 className="txt_form_note">
              {survey_desc ||
                `In order to recieve the book make sure you fill your address and phone correctly.`}
            </h3>
            <br />
            <div className="">
              <div className="form-row">
                <div className="form-group ">
                  <label> Name</label>
                  <input
                    onChange={(e) => this.onChange(e, "name")}
                    type="text"
                    name="name"
                    id="userName"
                    placeholder="Name"
                    className="form-control input_new"
                    value={this.state.name || ""}
                  />
                  <p id="nameerrorr" style={{ color: "red", "font-size" : "14px", "margin-top": "5px" }}></p>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group ">
                  <label>Mobile Number</label>
                  <input
                    onChange={(e) => this.onChange(e , "mobile")}
                    type="text"
                    minLength={"10"}
                    maxLength={"14"}
                    name="mobile"
                    id="numbers"
                    pattern="[1-9]{1}[0-9]{9}{+}"
                    placeholder="Mobile Number"
                    className="form-control input_new"
                    value={this.state.mobile || ""}
                  />
                  <p id="moberrorr" style={{ color: "red" , "font-size" : "14px", "margin-top": "5px"}}></p>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group ">
                  <label>Address</label>
                  <br />
                  <textarea
                    rows="4"
                    minLength={8}
                    pattern="[^\s]+"
                    className="form-control input_new"
                    name="address"
                    id="residence"
                    // value={this.state.address || ""}
                    onChange={(e) => this.onChange(e, "address")}
                  />
                  <p id="errorr" style={{ color: "red", "font-size" : "14px" , "margin-top": "5px"}}></p>
                  <p id="lengtherr" style={{ color: "red", "font-size" : "14px", "margin-top": "5px" }}></p>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group ">
                  <h5 className="infoText">BJP Karyakarta's Only</h5>
                  <label>Select State</label>
                  <Select
                    styles={customStyles}
                    value={state}
                    onChange={(e, type) => this.handleChange(e, "state")}
                    className="basic-single"
                    classNamePrefix="select"
                    options={stateList}
                    placeholder="Select State"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group ">
                  <label>Select Vidhansabha</label>
                  <Select
                    styles={customStyles}
                    value={vsabha}
                    onChange={(e, type) => this.handleChange(e, "vsabha")}
                    className="basic-single"
                    classNamePrefix="select"
                    options={vsabhaList}
                    placeholder="Select Vidhansabha"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group ">
                  <label>Booth Number</label>
                  <input
                    onChange={(e) => this.onChange(e)}
                    type="number"
                    name="boothno"
                    placeholder="Booth Number"
                    className="form-control input_new"
                  />
                </div>
              </div>
            </div>
            <div className=" mt-3">
              <div className="">
                <div className="form-group ">
                  <button className="btn btn_orng" onClick={this.onSubmit}>
                    Submit
                  </button>
                </div>
              </div>
              {/* <div className="form-group col-xs-6">
                                <button className="btn btn_skip" onClick={()=>this.props.hideModal(lang.value)} >Skip</button>
                            </div> */}
            </div>
          </div>
          {/* <div className="disclaimer_div">
            <h4>PLEASE NOTE</h4>
            <p>{complete_msg}</p>
          </div> */}
        </div>
      </div>
    );
  }
}

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    borderBottom: "1px solid lightgray",
    color: state.isSelected ? "black" : "black",
    backgroundColor: state.isSelected ? "#f8f8f8" : "#fff",
    fontSize: 13,
    minHeight: 35,
  }),
  control: (provided) => ({
    ...provided,
    marginTop: "5%",
    fontSize: 13,
    minWidth: 160,
    backgroundColor: "#f8f8f8",
    //   marginRight:10,
  }),
};
